"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secondary = exports.primary = void 0;
// TBC
var primary = {};
exports.primary = primary;
var secondary = {};
exports.secondary = secondary;
//# sourceMappingURL=base.js.map